import { useMutation } from "@apollo/client";
import { EVENT_CHECK_QR_GENERATE } from "graphql/mutation/event-gql";
import { successNotification, errorNotification } from "components/request-result";

const useMutationEventCheckQrGenerate = ({
    onCompleted,
    notifySuccess = true,
    notifyError = true,
} = {}) => {
    const [ _setEventCheckQrGenerate, { loading } ] = useMutation(EVENT_CHECK_QR_GENERATE, {
        onCompleted(data) {
            const payload = data?.eeCheckQrGenerate;

            if (notifySuccess && payload?.exhibitionEvent?.getCheckQrCodeUrl)
            {
                successNotification({
                    title: payload.label,
                    description: payload.message
                });
            }

            onCompleted?.(payload);
        },
        onError: notifyError ? errorNotification : undefined,
    });

    return {
        _setEventCheckQrGenerate,
        loadingMutationEventCheckQrGenerate: loading,
    };
};

export default useMutationEventCheckQrGenerate;
